import ElementConfig from '../classes/definitions/formItem/ElementConfig';
import FormItem from '../classes/definitions/formItem/FormItem';
var variantSchema = {
    price: new FormItem({
        elementConfig: new ElementConfig({
            className: 'form-control',
            type: 'number',
        }),
        elementType: 'input',
        label: 'Цена *',
        value: '',
        validation: {
            required: true,
        },
        valid: false,
        touched: false,
        errorMsg: 'Моля, въвдете валидна цена',
    }),
    old_price: new FormItem({
        elementConfig: new ElementConfig({
            className: 'form-control',
            type: 'number',
        }),
        elementType: 'input',
        label: 'Стара цена',
        value: '',
        validation: {
            required: false,
        },
        valid: true,
        touched: false,
        errorMsg: 'Моля, въвдете валидна стара цена',
    }),
    status: new FormItem({
        elementConfig: new ElementConfig({
            className: 'form-control',
            options: [],
        }),
        elementType: 'dropdown',
        label: 'Статус',
        value: '',
        validation: {
            required: true,
        },
        valid: false,
        touched: false,
        errorMsg: 'Моля, въведете валиден статус',
    }),
    barcode: new FormItem({
        elementConfig: new ElementConfig({
            className: 'form-control',
            type: 'text',
        }),
        elementType: 'input',
        label: 'Баркод *',
        value: '',
        validation: {
            required: true,
        },
        valid: false,
        touched: false,
        errorMsg: 'Моля, въвдете валиден баркод',
    }),
    option_value: new FormItem({
        elementConfig: new ElementConfig({
            className: 'form-control',
        }),
        elementType: 'autocomplete',
        label: 'Option Value *',
        value: false,
        validation: {
            required: true,
        },
        valid: false,
        touched: false,
        errorMsg: 'Моля, въведете валиден Option Value',
    }),
    packaging: new FormItem({
        elementConfig: new ElementConfig({
            className: 'form-control',
            type: 'text',
        }),
        elementType: 'input',
        label: 'Разфасовка',
        value: '',
        validation: {
            required: false,
        },
        valid: true,
        touched: false,
        errorMsg: 'Моля, въвдете валидна разфасовка',
    }),
    bg_composition: new FormItem({
        elementConfig: new ElementConfig({
            className: 'form-control',
        }),
        elementType: 'textarea',
        label: 'Състав на български',
        value: null,
        validation: {
            required: false,
        },
        valid: true,
        touched: false,
        errorMsg: 'Моля, въвдете валиден състав',
    }),
    en_composition: new FormItem({
        elementConfig: new ElementConfig({
            className: 'form-control',
        }),
        elementType: 'textarea',
        label: 'Състав на английски',
        value: null,
        validation: {
            required: false,
        },
        valid: true,
        touched: false,
        errorMsg: 'Моля, въвдете валиден състав',
    }),
    use_as_main_in_list: new FormItem({
        elementConfig: new ElementConfig({
            className: 'form-control',
        }),
        elementType: 'checkbox',
        label: 'Главен вариант за страниците с продуктите',
        value: false,
        validation: {
            required: false,
        },
        valid: true,
        touched: false,
        errorMsg: 'Трябва да бъде селектирано',
    }),
    position: new FormItem({
        elementConfig: new ElementConfig({
            className: 'form-control',
            type: 'number',
        }),
        elementType: 'input',
        label: 'Позиция',
        value: 50,
        validation: {
            required: false,
        },
        valid: true,
        touched: false,
        errorMsg: 'Моля, въведете валидна позиция',
    }),
    default: new FormItem({
        elementConfig: new ElementConfig({
            className: 'form-control',
        }),
        elementType: 'checkbox',
        label: 'Главен',
        value: false,
        validation: {
            required: false,
        },
        valid: true,
        touched: false,
        errorMsg: 'Трябва да бъде селектирано',
    }),
    external_id: new FormItem({
        elementConfig: new ElementConfig({
            className: 'form-control',
            type: 'text',
        }),
        elementType: 'input',
        label: 'ERP ID *',
        value: '',
        validation: {
            required: true,
        },
        valid: false,
        touched: false,
        errorMsg: 'Моля, въвдете валиден ERP ID',
    }),
    gift: new FormItem({
        ///////////////////////////////////////////
        elementConfig: new ElementConfig({
            className: 'form-control',
        }),
        elementType: 'autocomplete',
        label: 'Подарък',
        value: null,
        validation: {
            required: false,
        },
        valid: false,
        touched: false,
        errorMsg: 'Моля, въвдете валиден Option Type',
    }),
    stock_status: new FormItem({
        elementConfig: new ElementConfig({
            className: 'form-control',
            options: [],
        }),
        elementType: 'dropdown',
        label: 'Наличност',
        value: '',
        validation: {
            required: true,
        },
        valid: false,
        touched: false,
        errorMsg: 'Моля, въведете валидна наличност',
    }),
};
export default variantSchema;



//////////////////
// WEBPACK FOOTER
// ./src/schemas/variantSchema.ts
// module id = 505
// module chunks = 0